// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    MORTGAGE_FORM_ERROR: 'mortgage_form_error_',
};